import img1 from "../../assets/images/Odoo/oddo1.jpg";
import img2 from "../../assets/images/Odoo/oddo2.webp";
import img3 from "../../assets/images/Odoo/oddo3.jpg";
import icon1 from "../../assets/images/Odoo/service-icon1.svg";
import icon2 from "../../assets/images/Odoo/service-icon3.svg";
import icon3 from "../../assets/images/Odoo/service-icon5.svg";
import './service1.css';

export default function Service1() {
    return (
        <>
          <section className="services-five">
            <div className="auto-container">
                <div className="sec-title-three style-two centered">
                    {/* <div className="sec-title_title">Our Best Services</div> */}
                    <h2 className="sec-title_heading">Get The Best Service Solution</h2>
                </div>
                <div className="row clearfix">
                    {/* Service Block Four */}
                    <div className="service-block_four col-lg-4 col-md-6 col-sm-12">
                        <div className="service-block_four-inner">
                            <div className="service-block_four-image">
                                <img src={img1} alt="" />
                            </div>
                            <div className="service-block_four-content">
                                <div className="service-block_four-icon">
                                    <img src={icon1} alt="service icon" />
                                </div>
                                <h4 className="service-block_four-heading">
                                    <a href="#">Odoo Customization</a>
                                </h4>
                                <div className="service-block_four-text">
                                   Every business has unique requirements, and Odoo ERP’s flexibility allows you to tailor it to your specific needs. Customization helps maximize ROI, improve efficiency, and gain a competitive edge. Our experts ensure that Odoo aligns seamlessly with your workflows, making your ERP system work the way you need it to.
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Service Block Four */}
                    <div className="service-block_four col-lg-4 col-md-6 col-sm-12">
                        <div className="service-block_four-inner">
                            <div className="service-block_four-image">
                                <img src={img2} alt="" />
                            </div>
                            <div className="service-block_four-content">
                                <div className="service-block_four-icon">
                                    <img src={icon2} alt="service icon" />
                                </div>
                                <h4 className="service-block_four-heading">
                                    <a href="#">Odoo Implementation</a>
                                </h4>
                                <div className="service-block_four-text">
                                    A smooth Odoo implementation is essential for optimizing business operations and improving overall efficiency. Many organizations struggle with ERP deployment due to poor planning and execution. Our team ensures a hassle-free implementation, avoiding common pitfalls while accelerating adoption and productivity.
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Service Block Four */}
                    <div className="service-block_four col-lg-4 col-md-6 col-sm-12">
                        <div className="service-block_four-inner">
                            <div className="service-block_four-image">
                                <img src={img3} alt="" />
                            </div>
                            <div className="service-block_four-content">
                               <div className="service-block_four-icon">
                                    <img src={icon3} alt="service icon" />
                                </div>
                                <h4 className="service-block_four-heading">
                                    <a href="#">Odoo Migration</a>
                                </h4>
                                <div className="service-block_four-text">
                                    Our experienced professionals handle seamless data migration, ensuring minimal downtime and a smooth transition to Odoo’s advanced cloud-based ecosystem. Whether you're moving from an older Odoo version or an entirely different ERP, we guarantee a secure and efficient migration process.
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        </>
    );
}